import { Component, Input } from '@angular/core';

import { B2CProfile } from '../models/profile.model';
import { UserProfile } from '../models/userProfile.model';

@Component({
  selector: 'app-profile-basic-information',
  templateUrl: './basic-information.component.html',
  styleUrls: ['./basic-information.component.scss'],
  standalone: false,
})
export class BasicInformationComponent {
  @Input()
  public profile: UserProfile;

  @Input()
  public b2cProfile: B2CProfile;
}
